"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSampleItems = void 0;

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _immutable = require("immutable");

var _ActionTypes = require("crm_data/actions/ActionTypes");

// For sample events, see:
// crm_ui/constants/sampleData/sampleTimelineEvents
var addSampleItems = function addSampleItems(vid, sampleEvents) {
  return (0, _Dispatch.dispatchQueue)(_ActionTypes.ADD_SAMPLE_TIMELINE_ITEMS, {
    vid: vid,
    sampleEvents: (0, _immutable.fromJS)(sampleEvents)
  }).done();
};

exports.addSampleItems = addSampleItems;